"use strict";

var _classCallCheck = require("/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _axios = _interopRequireDefault(require("axios"));
var _jsBridge = _interopRequireDefault(require("@xpeng/js-bridge"));
var _url = _interopRequireDefault(require("./url"));
var _miniInit = require("./mini-init");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
var emptyFunc = function emptyFunc() {};
var RequestTool = /*#__PURE__*/function () {
  // 标识并发请求
  function RequestTool(config) {
    var _this = this;
    _classCallCheck(this, RequestTool);
    _defineProperty(this, "debug", void 0);
    _defineProperty(this, "key", void 0);
    _defineProperty(this, "baseUrl", void 0);
    _defineProperty(this, "redirectIng", false);
    _defineProperty(this, "cancelAppLogin", void 0);
    _defineProperty(this, "showError", void 0);
    _defineProperty(this, "processGetParams", void 0);
    _defineProperty(this, "processPostParams", void 0);
    _defineProperty(this, "processPostUrlParams", void 0);
    _defineProperty(this, "returnData", void 0);
    _defineProperty(this, "miniProgramLoginUrl", void 0);
    _defineProperty(this, "getMiniProgramLoginUrl", void 0);
    _defineProperty(this, "popupAppLogin", void 0);
    _defineProperty(this, "getExt", void 0);
    _defineProperty(this, "checkMiniProgram", function () {
      var UA = window.navigator.userAgent;
      return /miniProgram/i.test(UA) || /swan\//.test(UA) || /toutiaomicroapp/i.test(UA) || /AliApp\(TB/i.test(UA) || /AliApp\(TM/i.test(UA) || /jdapp/i.test(UA) && /jdmp/i.test(UA);
    });
    _defineProperty(this, "redirectToLogin", function (url) {
      var UA = window.navigator.userAgent;
      var isWXApp = /micromessenger/i.test(UA) && /miniProgram/i.test(UA); // 微信小程序

      var isMyApp = /AliApp/i.test(UA) && /miniProgram/i.test(UA); // 支付宝小程序

      var isSwan = /swan\//.test(UA); // 百度小程序

      var isTTApp = /toutiaomicroapp/i.test(UA); // 头条小程序

      var isKsApp = /KUAISHOU/i.test(UA) && /miniProgram/i.test(UA); // 头条小程序

      var isTBM = /AliApp\(TB/i.test(UA) || /AliApp\(TM/i.test(UA); // 淘宝/天猫app

      var isJdApp = /jdapp/i.test(UA) && /jdmp/i.test(UA); // 京东小程序

      if (isWXApp) {
        return (0, _miniInit.wxInit)().then(function (wx) {
          return wx.miniProgram.redirectTo({
            url: url
          });
        });
      } else if (isMyApp) {
        return (0, _miniInit.myInit)().then(function (my) {
          return my.redirectTo({
            url: url
          });
        });
      } else if (isTBM) {
        return (0, _miniInit.myInit)().then(function (my) {
          return my.redirectTo({
            url: url
          });
        });
      } else if (isTTApp) {
        return (0, _miniInit.ttInit)().then(function (tt) {
          return tt.miniProgram.redirectTo({
            url: url
          });
        });
      } else if (isSwan) {
        return (0, _miniInit.swanInit)().then(function (swan) {
          return swan.webView.redirectTo({
            url: url
          });
        });
      } else if (isKsApp) {
        return (0, _miniInit.ksInit)().then(function (ks) {
          return ks.redirectTo({
            url: url
          });
        });
      } else if (isJdApp) {
        return (0, _miniInit.jdInit)().then(function (jd) {
          return jd.miniProgram.redirectTo({
            url: url
          });
        });
      } else {
        return Promise.reject('暂不支持的小程序');
      }
    });
    _defineProperty(this, "removeUrlCode", function (params) {
      if (params.frontRedirect) {
        params.frontRedirect = params.frontRedirect.replace(/([?&])code=([^?&=]+)/, '$1').replace(/\?&/, '?').replace(/&&/, '&');
      }
      if (params.redirectURL) {
        params.redirectURL = params.redirectURL.replace(/([?&])code=([^?&=]+)/, '$1').replace(/\?&/, '?').replace(/&&/, '&');
      }
      return params;
    });
    this.debug = config.debug || false;
    this.key = config.key;
    this.baseUrl = config.baseUrl;
    this.cancelAppLogin = config.cancelAppLogin;
    this.showError = config.showError;
    this.processGetParams = config.processGetParams;
    this.processPostParams = config.processPostParams;
    this.processPostUrlParams = config.processPostUrlParams || function () {
      return {};
    };
    this.returnData = config.returnData;
    this.miniProgramLoginUrl = config.miniProgramLoginUrl || '';
    this.popupAppLogin = config.popupAppLogin || emptyFunc;
    this.getMiniProgramLoginUrl = config.getMiniProgramLoginUrl || function () {
      return _this.miniProgramLoginUrl;
    };
    this.getExt = config.getExt || emptyFunc;
  }
  /**
   * 获取APP登录code
   */
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _createClass(RequestTool, [{
    key: "loginInApp",
    value: function loginInApp() {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        if (_this2.debug) _this2.showError('start get auth code');
        var ext = _this2.getExt(); // eslint-disable-next-line @typescript-eslint/no-explicit-any

        var params = {
          bizType: _this2.key,
          target: _this2.key
        };
        if (ext) {
          params.ext = ext;
        } // 兜底，app没有回调的降级处理

        setTimeout(function () {
          _this2.popupAppLogin(function () {
            _this2.redirectIng = false;
          });
        }, 5000);
        _jsBridge.default.callHandler('getAuthCode', params).then(function (res) {
          if (Number(res.code) !== 1) {
            _this2.goToLogin().then(function () {// 成功登录刷新页面，so不处理
            }).catch(function (err) {
              reject(err);
            });
          } else {
            if (_this2.debug) _this2.showError("code: ".concat(res.data.code));
            resolve(res.data.code);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    }
    /**
     * 显示APP登录界面
     */
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  }, {
    key: "goToLogin",
    value: function goToLogin() {
      var _this3 = this;
      var _window = window,
        location = _window.location,
        navigator = _window.navigator;
      return new Promise(function (_resolve, reject) {
        var ext = _this3.getExt();
        var params = {
          pageType: 'login',
          data: {
            direct: location.href
          }
        };
        if (ext) {
          params.ext = ext;
        }
        _jsBridge.default.callHandler('goToNativePage', params).then(function (data) {
          _this3.redirectIng = false;
          if (/Android|miuibrowser/i.test(navigator.userAgent)) {
            // 安卓取消登录
            _this3.cancelAppLogin();
          } else {
            if (data && data.code === 0) {
              // IOS取消登录
              _this3.cancelAppLogin();
            } else {
              // IOS登录成功刷新页面
              location.reload();
            }
          }
        }).catch(function (err) {
          _this3.redirectIng = false;
          reject(err);
        });
      });
    }
    /**
     * 获取APP端用户UID
     */
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  }, {
    key: "getLoginState",
    value: function getLoginState() {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        if (_this4.debug) _this4.showError('start get login state');
        _jsBridge.default.callHandler('getLoginState', {}).then(function (res) {
          if (res.data && typeof res.data === 'string') {
            res.data = JSON.parse(res.data);
          }
          var preUid = '0';
          var isAppLogin = Number(res.loginState) === 1 && res.data.uid;
          if (isAppLogin) {
            preUid = res.data.uid;
          }
          if (_this4.debug) _this4.showError("preUid: ".concat(preUid));
          resolve({
            preUid: preUid,
            isAppLogin: isAppLogin
          });
        }).catch(function (err) {
          reject(err);
        });
      });
    }
    /**
     * 刷新页面重置逻辑
     *
     * @param beforeReload 刷新页面前回调方法
     * @param reload       刷新页面回调方法
     */
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  }, {
    key: "beforeReload",
    value: function beforeReload(_beforeReload, reload) {
      if (_beforeReload) {
        _beforeReload().then(function () {
          reload();
        }).catch(function () {
          reload();
        });
      } else {
        reload();
      }
    }
    /**
     * 检查是否小程序
     */

    /**
     * 处理登录逻辑
     */
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  }, {
    key: "login",
    value: function login(callbackUrl, authUrl, beforeReload) {
      var _this5 = this;
      var disableMiniLogin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      // 调试模式，替换https为http
      if (this.debug) {
        callbackUrl = callbackUrl.replace('https://', 'http://');
      }
      return new Promise(function (_resolve, reject) {
        var _window2 = window,
          location = _window2.location,
          navigator = _window2.navigator;
        if (/xiaopeng/i.test(navigator.userAgent)) {
          // APP联登
          _this5.loginInApp().then(function (code) {
            (function (curCode) {
              _this5.beforeReload(beforeReload, function () {
                location.replace(callbackUrl + '&code=' + curCode); // 兜底处理，页面跳转失败的情况

                setTimeout(function () {
                  _this5.redirectIng = false;
                }, 3000);
              });
            })(code);
          }).catch(function (err) {
            reject(err);
          });
        } else if (_this5.checkMiniProgram()) {
          // 从url的参数中取出code
          var code = _url.default.getUrlParameter(location.href, 'code');
          var codeT = _url.default.getUrlParameter(location.href, 't');
          var isValid = !!code; // code 有效期为 5 分分钟，这里限制为 3 分钟

          if (codeT && +new Date() - parseInt(codeT) > 1000 * 60 * 3) {
            isValid = false;
          }
          if (isValid) {
            // 小程序联登
            (function (curCode) {
              _this5.beforeReload(beforeReload, function () {
                location.replace(callbackUrl + '&code=' + curCode); // 兜底处理，页面跳转失败的情况

                setTimeout(function () {
                  _this5.redirectIng = false;
                }, 3000);
              });
            })(code);
          } else if (!disableMiniLogin) {
            var miniProgramLoginUrl = _this5.getMiniProgramLoginUrl();
            if (miniProgramLoginUrl) {
              // 调出小程序登录页面
              _this5.redirectToLogin(miniProgramLoginUrl).catch(function (err) {
                reject(err);
              });
            } else {
              alert('请配置小程序登录链接：miniProgramLoginUrl');
            }
          } else {
            reject();
          }
        } else {
          // H5联登 & 微信联登
          (function (curAuthUrl) {
            _this5.beforeReload(beforeReload, function () {
              _this5.redirectIng = false; // 支付宝小程序webview，需把302跳转换成前端跳转

              if (/alipayclient/i.test(window.navigator.userAgent)) {
                _axios.default.get(curAuthUrl + '&async=true', {
                  withCredentials: true
                }).then(function (res) {
                  location.replace(res.data.data.loginUrl);
                }).catch(function (err) {
                  reject(err);
                });
              } else {
                location.replace(curAuthUrl);
              }
            });
          })(authUrl);
        }
      });
    }
    /**
     * 创建axios请求
     *
     * @param url 请求链接
     * @param method 请求方法
     * @param params 请求参数
     * @param config 请求设置
     */
  }, {
    key: "createAxios",
    value: function createAxios(url, method, params) {
      var _this6 = this;
      var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var isAppLogin = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var reqParams = params || {}; // 小程序处理窜号问题

      if (this.checkMiniProgram()) {
        var preUid = _url.default.getUrlParameter(location.href, 'uid');
        if (preUid) {
          reqParams = Object.assign(reqParams, {
            preUid: preUid
          });
        }
      }
      var ext = this.getExt();
      if (ext) {
        reqParams.ext = ext;
      }
      var getParams = reqParams;
      if (this.processGetParams) {
        getParams = this.processGetParams(getParams);
      }
      if (method === 'POST') {
        getParams = this.processPostUrlParams(reqParams);
      }
      var postParams = method === 'POST' ? reqParams : {};
      if (this.processPostParams) {
        postParams = this.processPostParams(postParams);
      }
      if (this.checkMiniProgram()) {
        getParams = this.removeUrlCode(getParams);
        postParams = this.removeUrlCode(postParams);
      }
      return new Promise(function (resolve, reject) {
        try {
          _axios.default.request(Object.assign({
            baseURL: _this6.baseUrl,
            url: url,
            method: method,
            params: getParams,
            data: postParams,
            timeout: 10000,
            responseType: 'json'
          }, config)).then(function (res) {
            var returnData = res.data;
            if (_this6.returnData) {
              returnData = _this6.returnData(res);
            }
            if (res && res.data && res.data.code === 12150008) {
              if (config.disableLogin) {
                resolve(returnData);
              } else if (/xiaopeng/i.test(navigator.userAgent) && !isAppLogin && config.disableAppLogin) {
                resolve(returnData);
              } else {
                var data = res.data.data;
                if (!_this6.redirectIng) {
                  _this6.redirectIng = true; // 处理并发请求

                  var authUrl = data.authUrl;
                  if (/micromessenger/i.test(navigator.userAgent) && !config.disableWechatUrl && data.wechatUrl) {
                    authUrl = data.wechatUrl;
                  }
                  _this6.login(data.callbackUrl, authUrl, config.beforeReload, config.disableMiniLogin).then(function () {
                    _this6.redirectIng = false; // 成功登录刷新页面，so不处理
                  }).catch(function (err) {
                    _this6.redirectIng = false;
                    if (config.disableMiniLogin) {
                      resolve(returnData);
                    } else {
                      reject(err);
                    }
                  });
                }
              }
            } else {
              if (config.fullData) {
                resolve(res.data);
              } else {
                resolve(returnData);
              }
            }
          }).catch(function (err) {
            if (typeof config.showError == 'function') {
              config.showError(err);
            } else {
              _this6.showError(err);
            }
            reject(err);
          }).catch(function (err) {
            reject(err);
          });
        } catch (err) {
          reject(err);
        }
      });
    }
    /**
     *  移除登录成功回调url的 code 参数
     */

    /**
     * 使用 GET 请求服务端接口
     * @param url 请求地址
     * @param params 请求参数
     * @param options 请求设置
     */
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  }, {
    key: "get",
    value: function get(url) {
      var _this7 = this;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var userAgent = window.navigator.userAgent;
      if (/xiaopeng/i.test(userAgent)) {
        // 获取当前用户UID，避免串号
        return new Promise(function (resolve, reject) {
          _this7.getLoginState().then(function (_ref) {
            var preUid = _ref.preUid,
              isAppLogin = _ref.isAppLogin;
            params.preUid = preUid;
            _this7.createAxios(url, 'GET', params, options, isAppLogin).then(function (res) {
              resolve(res);
            }).catch(function (err) {
              reject(err);
            });
          });
        });
      } else {
        return this.createAxios(url, 'GET', params, options);
      }
    }
    /**
     * 使用 POST 请求服务端接口
     * @param url 请求地址
     * @param params 请求参数
     * @param options 请求设置
     */
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  }, {
    key: "post",
    value: function post(url) {
      var _this8 = this;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      // 设置请求头
      var headers = options.headers ? options.headers : {};
      Object.assign(headers, {
        'Content-Type': 'application/json; charset=UTF-8'
      });
      Object.assign(options, {
        headers: headers
      });
      var userAgent = window.navigator.userAgent;
      if (/xiaopeng/i.test(userAgent)) {
        // 获取当前用户uid，避免串号
        return new Promise(function (resolve, reject) {
          _this8.getLoginState().then(function (_ref2) {
            var preUid = _ref2.preUid,
              isAppLogin = _ref2.isAppLogin;
            params.preUid = preUid;
            _this8.createAxios(url, 'POST', params, options, isAppLogin).then(function (res) {
              resolve(res);
            }).catch(function (err) {
              reject(err);
            });
          });
        });
      } else {
        return this.createAxios(url, 'POST', params, options);
      }
    }
  }]);
  return RequestTool;
}();
var reqObj = null; // eslint-disable-next-line @typescript-eslint/explicit-function-return-type

function _default(config) {
  if (reqObj) {
    return reqObj;
  }
  reqObj = new RequestTool(config);
  return reqObj;
}